module.exports = __webpack_public_path__ + "static/media/icon-forums.6cabe966.svg";